'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'


const CURRENT_YEAR = new Date().getFullYear()

const ASK_AI_PROMPT = 'Who is GHL Prime and what services do they offer?'
const ASK_AI_ASSISTANTS = [
  { name: 'ChatGPT', icon: '/ai-icons/openai.svg', buildUrl: (q) => `https://chatgpt.com/?prompt=${q}` },
  { name: 'Claude', icon: '/ai-icons/claude.svg', buildUrl: (q) => `https://claude.ai/new?q=${q}` },
  { name: 'Perplexity', icon: '/ai-icons/perplexity.svg', buildUrl: (q) => `https://www.perplexity.ai/search?q=${q}` },
  { name: 'Gemini', icon: '/ai-icons/gemini.svg', buildUrl: (q) => `https://gemini.google.com/app?q=${q}` },
]

const footerCompany = [
  { label: 'About', to: '/about' },
  { label: 'Team', to: '/team' },
  { label: 'Hire an Individual', to: '/hire-an-individual' },
  { label: 'Case Studies', to: '/case-studies' },
  { label: 'Blog', to: '/blog' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Certifications', to: '/#certifications' },
  { label: 'Contact', to: '/contact' },
]

const footerServices = [
  { label: 'GHL Setup', to: '/services/ghl-setup' },
  { label: 'Automation', to: '/services/automation' },
  { label: 'SaaS CRM', to: '/services/saas-crm' },
  { label: 'White-Label Support', to: '/services/white-label-support' },
  { label: 'Vibe Coding', to: '/services/vibe-coding' },
  { label: 'AI Agent Builder', to: '/services/ai-agent-builder' },
  { label: 'Custom SaaS Development', to: '/services/custom-saas-development' },
  { label: 'Figma to Code', to: '/services/figma-to-code' },
  { label: 'App Development', to: '/services/app-development' },
  { label: 'SaaS Customer Support', to: '/services/saas-customer-support' },
  { label: 'All Services', to: '/services' },
]

const socialLinks = [
  {
    label: 'Google Business Profile',
    href: 'https://share.google/lbJWwNjrKIvlg1LOK',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M21.6 12.23c0-.68-.06-1.33-.17-1.96H12v3.71h5.38a4.6 4.6 0 0 1-2 3.02v2.47h3.24c1.9-1.75 2.98-4.33 2.98-7.24Z" />
        <path fill="currentColor" d="M12 22c2.7 0 4.97-.9 6.62-2.43l-3.24-2.47c-.9.6-2.04.97-3.38.97-2.6 0-4.8-1.76-5.59-4.12H3.06v2.55A10 10 0 0 0 12 22Z" />
        <path fill="currentColor" d="M6.41 13.95A6 6 0 0 1 6.1 12c0-.68.12-1.34.31-1.95V7.5H3.06A10 10 0 0 0 2 12c0 1.62.39 3.16 1.06 4.5l3.35-2.55Z" />
        <path fill="currentColor" d="M12 5.93c1.47 0 2.8.5 3.85 1.52l2.88-2.88C16.96 2.94 14.7 2 12 2a10 10 0 0 0-8.94 5.5l3.35 2.55C7.2 7.69 9.4 5.93 12 5.93Z" />
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61573474861100',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M13.5 21v-7h2.34l.35-2.73H13.5V9.53c0-.79.22-1.33 1.35-1.33h1.44V5.78c-.25-.03-1.1-.1-2.08-.1c-2.06 0-3.48 1.26-3.48 3.58v2.01H8.39V14h2.34v7h2.77Z"/></svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/ghl-prime-llc',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.94 8.5H3.56V20h3.38V8.5Zm.22-3.56a1.96 1.96 0 1 0-3.92 0a1.96 1.96 0 0 0 3.92 0ZM20.44 13.02c0-3.45-1.84-5.05-4.29-5.05c-1.98 0-2.87 1.09-3.36 1.86V8.5H9.41c.05.88 0 11.5 0 11.5h3.38v-6.42c0-.34.02-.68.13-.92c.27-.68.89-1.38 1.93-1.38c1.36 0 1.9 1.04 1.9 2.57V20h3.38v-6.98Z"/></svg>
    ),
  },
  {
  label: 'Instagram',
  href: 'https://www.instagram.com/ghlprimellc/',
  icon: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2.163c3.204 0 3.584.012 4.85.07c3.252.148 4.771 1.691 4.919 4.919c.058 1.265.069 1.645.069 4.849c0 3.205-.012 3.584-.069 4.849c-.149 3.225-1.664 4.771-4.919 4.919c-1.266.058-1.644.07-4.85.07c-3.204 0-3.584-.012-4.849-.07c-3.26-.149-4.771-1.699-4.919-4.92c-.058-1.265-.07-1.644-.07-4.849c0-3.204.013-3.583.07-4.849c.149-3.227 1.664-4.771 4.919-4.919c1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072C2.695.272.273 2.69.073 7.051C.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948c.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072c4.354-.2 6.782-2.618 6.979-6.98c.059-1.28.073-1.689.073-4.948c0-3.259-.014-3.667-.072-4.947c-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324a6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8a4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881a1.44 1.44 0 0 0 0-2.881z"
      />
    </svg>
  ),
},
{
  label: 'Upwork',
  href: 'https://www.upwork.com/agencies/ghlprime/',
  icon: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M17.2 7.2a4.8 4.8 0 0 0-4.35 2.8c-1.08-1.63-1.8-3.43-2.13-5.3H8.3v6.18a2.02 2.02 0 1 1-4.03 0V7.2H2v3.68a4.3 4.3 0 0 0 8.6 0v-.55c.42.76.9 1.48 1.43 2.16l-1.2 5.67h2.32l.85-4.03c.95.67 2.04 1.04 3.2 1.04A4.99 4.99 0 0 0 22 10.2a3 3 0 0 0-.02-.32A4.79 4.79 0 0 0 17.2 7.2Zm0 5.67c-.77 0-1.5-.26-2.09-.74l.24-1.12a2.5 2.5 0 0 1 1.85-1.54c.16-.03.32-.05.49-.05a2.5 2.5 0 1 1-.49 4.95Z"
      />
    </svg>
  ),
}

]

export default function SiteFooter() {
  const pathname = usePathname()

  const handleFooterNavigate = () => {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  }

  return (
    <footer className="site-footer redesigned-footer">
      <div className="container footer-grid redesigned-footer-grid">
        <div className="footer-brand redesigned-footer-brand">
          <Link href="/" aria-label="Go to homepage" className="footer-brand-logo-link" onClick={handleFooterNavigate}>
            <img className="footer-logo footer-logo-external" src="/footer-logo.png" alt="GHL Prime" width="1262" height="274" loading="lazy" decoding="async" />
          </Link>
          <p>Your dedicated GoHighLevel & automation expert team 24/7, fully white-labeled.</p>
          <div className="footer-social-row">
            {socialLinks.map((item) => (
              <a key={item.label} href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.label} className="footer-social-link">
                {item.icon}
              </a>
            ))}
          </div>

          <div className="footer-legal-links">
            <Link href="/privacy-policy" onClick={handleFooterNavigate}>Privacy Policy</Link>
            <Link href="/terms" onClick={handleFooterNavigate}>Terms &amp; Conditions</Link>
          </div>
          <span className="footer-parent-brand">
            <a href="https://octopi-digital.com/" target="_blank" rel="noopener noreferrer">A specialized brand by Octopi Digital</a>
          </span>
          <div className="footer-ask-ai">
            <span className="footer-ask-ai-label">Ask AI about us</span>
            <div className="footer-ask-ai-row">
              {ASK_AI_ASSISTANTS.map((ai) => (
                <a
                  key={ai.name}
                  href={ai.buildUrl(encodeURIComponent(ASK_AI_PROMPT))}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-ask-ai-btn"
                  aria-label={`Ask ${ai.name} about GHL Prime`}
                  title={`Ask ${ai.name} about GHL Prime`}
                >
                  <img src={ai.icon} alt={`${ai.name} logo`} aria-hidden="true" width="16" height="16" loading="lazy" decoding="async" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div>
          <div className="footer-heading">Company</div>
          <ul>
            {footerCompany.map((item) => {
              const isHash = item.to.startsWith('/#')
              const isSamePage = pathname === '/' && isHash
              return (
                <li key={item.label}>
                  {isSamePage ? (
                    <a href={item.to} onClick={handleFooterNavigate}>{item.label}</a>
                  ) : (
                    <Link href={item.to} onClick={handleFooterNavigate}>{item.label}</Link>
                  )}
                </li>
              )
            })}
          </ul>
        </div>

        <div>
          <div className="footer-heading">Services</div>
          <ul>
            {footerServices.map((item) => {
              const isHash = item.to.includes('#')
              const isSamePage = pathname === '/services' && isHash
              return (
                <li key={item.label}>
                  {isSamePage ? (
                    <a href={item.to.slice(item.to.indexOf('#'))} onClick={handleFooterNavigate}>{item.label}</a>
                  ) : (
                    <Link href={item.to} onClick={handleFooterNavigate}>{item.label}</Link>
                  )}
                </li>
              )
            })}
          </ul>
        </div>

        <div className="footer-contact-column">
          <div className="footer-heading">Contact</div>
          <address className="footer-nap" style={{ fontStyle: 'normal', lineHeight: 1.6 }} itemScope itemType="https://schema.org/PostalAddress">
            <div><strong itemProp="name">GHL Prime LLC</strong></div>
            <div itemProp="streetAddress">4801 Lang Ave NE, Suite 110</div>
            <div>
              <span itemProp="addressLocality">Albuquerque</span>,{' '}
              <span itemProp="addressRegion">NM</span>{' '}
              <span itemProp="postalCode">87109</span>
            </div>
            <div itemProp="addressCountry">USA</div>
            <div><a href="tel:+15052075189" className="footer-email-link" itemProp="telephone">+1 505-207-5189</a></div>
            <div><a href="mailto:info@ghlprime.com" className="footer-email-link" itemProp="email">info@ghlprime.com</a></div>
          </address>
          <div style={{ marginTop: '14px' }}>
            <div className="footer-heading" style={{ marginBottom: '4px' }}>Office Location</div>
            <div style={{ lineHeight: 1.6 }}>Basundhara Residential Area, Dhaka, Bangladesh</div>
          </div>
          <div style={{ marginTop: '12px' }}>
            <a href="https://wa.me/15052075189" target="_blank" rel="noopener noreferrer" className="footer-hire-expert-link">Talk to Founder</a>
          </div>
        </div>
      </div>

      <div className="container footer-bottom redesigned-footer-bottom">
        <span>&copy; {CURRENT_YEAR} GHL Prime LLC. All rights reserved.</span>
      </div>
    </footer>
  )
}
